import { reloadUserData } from "../../../../user/services/store/authentication.actions";
import { zalandoService } from "../services/zalando.service";
import { zalandoReducerActions } from "../../../../_services/store";

export const testZalandoConnection = (clientUUID, credentials) => {
    return async (dispatch) => {
        dispatch(zalandoReducerActions.testConnectionRequest());
        try {
            const response = await zalandoService.testConnection(clientUUID, credentials);
            dispatch(zalandoReducerActions.testConnectionSuccess(response));
        } catch (error) {
            dispatch(zalandoReducerActions.testConnectionFailure(error));
        }
    };
};

export const connectZalando = (createDto) => {
    return async (dispatch) => {
        dispatch(zalandoReducerActions.connectRequest());
        try {
            const response = await zalandoService.connect(createDto);
            dispatch(zalandoReducerActions.connectSuccess(response));
            dispatch(reloadUserData());
        } catch (error) {
            dispatch(zalandoReducerActions.connectFailure(error));
        }
    };
};

export const disconnectZalando = (clientUUID) => {
    return async (dispatch) => {
        dispatch(zalandoReducerActions.disconnectRequest());
        try {
            await zalandoService.disconnect(clientUUID);
            dispatch(zalandoReducerActions.disconnectSuccess());
            dispatch(reloadUserData());
        } catch (error) {
            dispatch(zalandoReducerActions.disconnectFailure(error));
        }
    };
};

export const startZalandoPreImport = (request) => {
    return async (dispatch) => {
        dispatch(zalandoReducerActions.startPreImportRequest());
        try {
            const response = await zalandoService.startPreImport(request);
            dispatch(zalandoReducerActions.startPreImportSuccess(response));
            dispatch(reloadUserData());
        } catch (error) {
            dispatch(zalandoReducerActions.startPreImportFailure(error));
        }
    };
};

export const startZalandoFullImport = (request) => {
    return async (dispatch) => {
        dispatch(zalandoReducerActions.startFullImportRequest());
        try {
            await zalandoService.startFullImport(request);
            dispatch(zalandoReducerActions.startFullImportSuccess());
        } catch (error) {
            dispatch(zalandoReducerActions.startFullImportFailure(error));
        }
    };
};
